import { Card, Button, Avatar } from "@aws-amplify/ui-react";

import { useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { Placeholder } from "@aws-amplify/ui-react";
export const CommentCard = ({ comment, user, onDeleteComment, onCommentClicked }) => {
    const [showAvatar, setShowAvatar] = useState(true)
    const userIsAuthor = comment.author === user
    const cardClass = userIsAuthor ? 'clickable' : 'non-clickable'
    const [showModal, setShowModal] = useState(false)
    const [isBeingDelted, setIsBeingDeleted] = useState(false)
    return (
        <>
            {
                isBeingDelted &&
                <div>
                    <Placeholder style={{ height: '150px' }} />
                </div>
            }
            {!isBeingDelted &&
                <Card variation="elevated mb-2" className={cardClass} onClick={onCommentClicked}>
                    <div className="d-flex flex-row justify-content-start">
                        <div>
                            {comment?.author && showAvatar &&
                                <Avatar
                                    className="post-avatar"
                                    src={`https://liftolog-media.s3.eu-central-1.amazonaws.com/avatars/${comment?.author}.jpg`}
                                    onError={(e) => {
                                        console.log(e)
                                        setShowAvatar(false)
                                    }} />

                            }
                            {!showAvatar &&
                                <Avatar className="post-avatar" />
                            }
                        </div>
                        <div className="d-flex flex-column w-100" >
                            <div className="d-flex justify-content-between">
                                <h6>{comment.authorName}</h6>
                                {userIsAuthor &&
                                    <CloseButton onClick={() =>
                                        setShowModal(true)
                                    } />
                                }
                            </div>
                            <p className="small">{new Date(comment.timestamp).toLocaleDateString()}</p>
                            <p>{comment.content}</p>
                        </div>
                    </div>
                </Card>
            }
            <Modal
                show={showModal}
                onHide={() => { setShowModal(false) }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Comment?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the comment?
                </Modal.Body>
                <Modal.Footer>
                    <Button className="m-1" variation="default" onClick={() => { setShowModal(false) }}>
                        Cancel
                    </Button>
                    <Button className="m-1" variation="primary" colorTheme="warning" onClick={async () => {
                        setShowModal(false)
                        setIsBeingDeleted(true)
                        await onDeleteComment()
                        setIsBeingDeleted(false)
                    }}>Yes, delete</Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}